import Base from './Base.js';

export default class EnquiriesSent extends Base {
  static get _path() {
    return 'es6/src/storage/models/EnquiriesSent';
  }

  static get _defaultValue() {
    return [];
  }
}
